import { c as _c } from "react/compiler-runtime";
import Typography, { type TypographyVariant } from '@precis-digital/kurama/Typography';
import { styled } from '@precis-digital/kurama/utils';
import { type PercentageStatus, getPercentageDisplayValueAndStatus } from 'shared/utils';
import { getTextColorByDifferenceIndicatorAndColorScheme } from './PercentageChip';
interface PercentageTypographyProps {
  presentValue: number;
  previousValue: number;
  variant?: TypographyVariant;
  reverseColorScheme?: boolean;
}
const PercentageTypography = t0 => {
  const $ = _c(8);
  const {
    presentValue,
    previousValue,
    reverseColorScheme: t1,
    variant: t2
  } = t0;
  const reverseColorScheme = t1 === undefined ? false : t1;
  const variant = t2 === undefined ? "body3" : t2;
  let t3;
  if ($[0] !== presentValue || $[1] !== previousValue) {
    t3 = getPercentageDisplayValueAndStatus(presentValue, previousValue);
    $[0] = presentValue;
    $[1] = previousValue;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    displayValue,
    percentageStatus
  } = t3;
  let t4;
  if ($[3] !== displayValue || $[4] !== percentageStatus || $[5] !== reverseColorScheme || $[6] !== variant) {
    t4 = <StyledTypography variant={variant} $differenceIndicator={percentageStatus} $reverseColorScheme={reverseColorScheme}>{displayValue}</StyledTypography>;
    $[3] = displayValue;
    $[4] = percentageStatus;
    $[5] = reverseColorScheme;
    $[6] = variant;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export default PercentageTypography;
const StyledTypography = styled(Typography)<{
  $differenceIndicator: PercentageStatus;
  $reverseColorScheme: boolean;
}>(({
  theme,
  $differenceIndicator: differenceIndicator,
  $reverseColorScheme: reverseColorScheme
}) => {
  const color = getTextColorByDifferenceIndicatorAndColorScheme({
    theme,
    differenceIndicator,
    reverseColorScheme
  });
  return {
    color
  };
});